import React from "react";
import { Input, Select } from "antd";
import { useSelector } from "react-redux";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";

const AdminOrganizationsStatisticsActions = ({
  setStatisticsArray,
  setStatisticsTypeValue,
}) => {
  const { organizationsStatistics } = useSelector(
    (state) => state.organizationsStatisticsReducer
  );

  const onSearch = (value) => {
    const searchedArray = organizationsStatistics.filter((org) =>
      org.organizationName
        .toLowerCase()
        .includes(value.target.value.toLowerCase())
    );
    setStatisticsArray(searchedArray);
  };

  const changeStatistics = (value) => {
    setStatisticsTypeValue(value);
  };

  const chooseStatisticsOpions = [
    {
      label: "Посещения",
      value: "visits",
    },
    {
      label: "Поръчки",
      value: "orders",
    },
    {
      label: "MyPos Плащания",
      value: "myPosPayments",
    },
  ];
  return (
    <>
      <div className="admin-organizations-statistics-datepicker-container">
        <DatePickerComponent />
      </div>
      <div className="admin-organizations-statistics-search-container">
        <Input
          placeholder="Търсене"
          onChange={(e) => onSearch(e)}
          className="admin-organizations-statistics-search-input"
        />
        <Select
          defaultValue="visits"
          className="admin-organizations-statistics-search-select"
          onChange={changeStatistics}
          options={chooseStatisticsOpions}
        />
      </div>
    </>
  );
};

export default AdminOrganizationsStatisticsActions;
